<template>
  <div class="weekly-recharge-benefit">
    <!-- 顶部标题图片 -->
    <div :class="isFull == 1 ? 'header-image top_information' : ' header-image'">
      <van-nav-bar
        left-arrow
        @click-left="onClickLeft"
        placeholder
      />
    </div>
    <div class="weekly-recharge-content-height">
      <div class="weekly-recharge-content">
          <!-- 倒计时 -->
        <div class="countdown-bar"> <span class="countdown-text">{{ countdownText }}</span> </div>
        <!-- 当前充值金额 -->
        <div class="current-amount-bar">
          <span class="amount-label">{{ $t('weekly_recharge.current_amount') }}</span>
          <img src="../assets/img/coin11.png" class="diamond-icon" />
          <span class="amount-value">{{ formatNumber(totalRecharge) }}</span>
        </div>

        <!-- 充值福利列表 -->
        <div class="welfare-list">
          <div 
            v-for="(item, index) in welfareList" 
            :key="item.id"
            class="welfare-item"
            :class="{ 
              'reached': item.is_reached, 
              'current-level': item.is_current_level,
              'claimed': item.is_claimed
            }"
          >
            <!-- 进度线和圆点 -->
            <div class="progress-line">
              <div class="line-dot" :class="{ 'active': item.is_reached }"></div>
              <div class="line-bar" :class="{ 'active': item.is_reached }" v-if="index < welfareList.length - 1"></div>
            </div>

            <!-- 福利内容 -->
            <div class="welfare-content">
              <!-- 左侧：充值金额 -->
              <div class="welfare-left">
                <div class="amount-display">
                  <img src="../assets/img/coin11.png" class="small-diamond" />
                  <span class="amount-text">{{ formatNumber(item.start_amount) }}</span>
                </div>
                
              </div>

              <!-- 右侧:达成状态 -->
              <div class="welfare-right">
                <div class="passed-info">
                  <div class="passed-left">
                    <img src="../assets/img/weekly-recharge-user.png" class="avatar-small" />
                    <span class="passed-count">{{ formatNumber(item.passed_users) }}</span>
                    <span class="passed-label">{{ $t('weekly_recharge.passed') }}</span>
                  </div>
                  <span class="user-avatars">
                    <!-- 这里可以显示已达成用户的头像 -->
                    <img :src="value.head_image" class="avatar-small" v-for="(value,j) in item.passed_users_list" :key="j" v-if="j < 3"/>
                  </span>
                </div>
              </div>
               
            </div>
              <!-- 奖励物品 -->
            <div class="reward-items">
              <div class="reward-item" v-for="t,j in item.reward_list" :key="j">
                <!-- 支持 SVGA 格式 -->
                <div v-if="isSvga(t.reward_image)" :ref="'svga-reward-' + index + '-' + j" class="svga-container"></div>
                <img v-else :src="t.reward_image" class="reward-image" />
                <div class="reward-duration">x {{ t.reward_duration }} {{ $t('weekly_recharge.day') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="weekly_recharge_benefit_recharge_btn" @click="onClickRecharge">{{ $t('weekly_recharge.recharge_now') }}</div>
    </div>
   
   
  </div>
</template>

<script>
import axios from 'axios'
import { Toast } from 'vant'
import SVGA from "svgaplayerweb";

export default {
  name: 'WeeklyRechargeBenefit',
  data() {
    return {
      totalRecharge: 0,
      countdownText: '',
      remainingTime: 0,
      welfareList: [],
      countdownTimer: null,
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.loadWelfareList()
  },
  mounted() {
    this.startCountdown()
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
    }
  },
  methods: {
    onClickRecharge() {
      // 充值   跳转到充值页面
      window.location.href="live://live?action=Recharge"
    },
    // 加载福利列表
    async loadWelfareList() {
      try {
        const token = this.$route.query.token || ''
        const res = await axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=weekly_recharge&act=get_welfare_list", {
          params: { token: token }
        })
        const data = res.data
        if (data.status === 1) {
          this.totalRecharge = data.data.total_recharge || 0
          this.remainingTime = data.data.remaining_time || 0
          this.welfareList = data.data.welfare_list || []
          this.updateCountdownText()
          
          // 加载完成后播放 SVGA 动画
          this.$nextTick(() => {
            this.playAllSvga()
          })
        } else {
          Toast.fail(data.error || this.$t('common.load_failed'))
        }
      } catch (error) {
        console.error('加载福利列表失败:', error)
        Toast.fail(this.$t('common.load_failed'))
      }
    },

    // 判断是否为 SVGA 格式
    isSvga(url) {
      if (!url) return false
      const cleanUrl = url.split('?')[0].split('#')[0]
      const extension = cleanUrl.split('.').pop().toLowerCase()
      return extension === 'svga'
    },

    // 播放 SVGA 动画
    playSvga(url, refName) {
      if (!url || !this.isSvga(url)) return
      
      this.$nextTick(() => {
        const container = this.$refs[refName]
        // 处理单个元素或数组
        const targetContainer = Array.isArray(container) ? container[0] : container
        if (!targetContainer) {
          console.log('SVGA container not found:', refName)
          return
        }
        
        console.log('Playing SVGA:', url, 'in container:', refName)
        
        try {
          const player = new SVGA.Player(targetContainer)
          const parser = new SVGA.Parser()
          parser.load(url, (videoItem) => {
            if (!videoItem) {
              console.error('SVGA load failed:', url)
              return
            }
            console.log('SVGA loaded successfully:', videoItem)
            player.setVideoItem(videoItem)
            player.startAnimation()
          })
        } catch (error) {
          console.error('SVGA play error:', error)
        }
      })
    },

    // 播放所有 SVGA 动画
    playAllSvga() {
      this.welfareList.forEach((item, index) => {
        if (item.reward_list) {
          item.reward_list.forEach((reward, j) => {
            if (this.isSvga(reward.reward_image)) {
              this.playSvga(reward.reward_image, 'svga-reward-' + index + '-' + j)
            }
          })
        }
      })
    },
    // 开始倒计时
    startCountdown() {
      this.updateCountdownText()
      this.countdownTimer = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--
          this.updateCountdownText()
        } else {
          clearInterval(this.countdownTimer)
        }
      }, 1000)
    },

    // 更新倒计时文本
    updateCountdownText() {
      if (this.remainingTime <= 0) {
        this.countdownText = this.$t('weekly_recharge.expired')
        return
      }

      const days = Math.floor(this.remainingTime / 86400)
      const hours = Math.floor((this.remainingTime % 86400) / 3600)
      const minutes = Math.floor((this.remainingTime % 3600) / 60)
      const seconds = this.remainingTime % 60

      this.countdownText = `${days}${this.$t('weekly_recharge.days')} ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    },

    // 格式化数字（添加千分位）
    formatNumber(num) {
      if (!num) return '0'
      return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    // 返回上一页
    onClickLeft() {
       // 拦截关闭h5
      window.location.href="bogolive://exit"
    }
  }
}
</script>

<style scoped>









</style>



// WEBPACK FOOTER //
// src/components/WeeklyRechargeBenefit.vue